export enum FILE_UPLOAD_ERRORS {
  FILE_SIZE_ERROR = 'fileSizeError',
  FILE_TYPE_ERROR = 'fileTypeError',
  MIN_FILES_ERROR = 'minfilesError',
  MIN_FILES_LOAN_INSURANCE_ERROR = 'minfilesLoanInsuranceError',
  MAX_FILES_ERROR = 'maxFilesError',
  MAX_FILES_SIZE_ERROR = 'maxfilesSizeError',
}
